import { isDefinedString } from "et3-type-guards";
import getApproveRejectStore from "../../../../../../../stores/approval-reject-store";
import { TDescriptionType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import NonePendingResolve from "./NonePendingResolve";
import PendingResolve from "./PendingResolve";
import getKhattabat101CStore from "../../../../../../../stores/khattabat-stores/101c-stores";

const DescriptionDataSolve = withLiteObserverAndTheme<{
  userID: number;
  description: string;
  descriptionID: number;
  descriptionStatus: string;
  descriptionType: TDescriptionType;
  isPendingDescription: boolean;
}>((props) => {
  const {
    theme,
    userID,
    description,
    descriptionID,
    descriptionStatus,
    descriptionType,
    isPendingDescription
  } = props;
  const { colors } = theme;
  const userUUID = getKhattabat101CStore(userID).userUUID.get();

  return isDefinedString(description) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={420}
      height={80}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <PendingResolve
        dataStatusIsPending={isPendingDescription}
        acceptDataCallback={() => {
          return getApproveRejectStore().approveUserDescription(
            descriptionID,
            userID,
            userUUID,
            "USER_ADVANCED",
            descriptionType,
            true,
            ""
          );
        }}
        rejectDataCallback={() => {
          return getApproveRejectStore().rejectUserDescription(
            descriptionID,
            userID,
            userUUID,
            "USER_ADVANCED",
            descriptionType,
            true,
            ""
          );
        }}
      />
      <NonePendingResolve
        dataStatusIsPending={isPendingDescription}
        changeDataStatus={() => {
          if (descriptionStatus === "REJECTED") {
            return getApproveRejectStore().approveUserDescription(
              descriptionID,
              userID,
              userUUID,
              "USER_ADVANCED",
              descriptionType,
              false,
              ""
            );
          }
          if (descriptionStatus === "APPROVED") {
            return getApproveRejectStore().rejectUserDescription(
              descriptionID,
              userID,
              userUUID,
              "USER_ADVANCED",
              descriptionType,
              false,
              ""
            );
          }
          return null;
        }}
      />
    </ET3Div>
  ) : null;
});

export default DescriptionDataSolve;
